export const LESSONS_COUNT = 15;

export const TABLE_HEADERS = {
  lessonNumber: "Lesson Number",
  startingDate: "Starting Date",
  dateOfProficiency: "Date of Proficiency",
};

export const MODAL_TITLE = "Track Your Progress";
export const SAVE_BTN_TEXT = "Save";
export const CANCEL_BTN_TEXT = "Download PDF";

export const PDF = {
  title: "Monastery Progress Report",
  filename: "Progress_Report.pdf",
  emailText: "Email this to: support@mynirva.com",
  email: "support@mynirva.com",
};

export const API_ENDPOINTS = {
  get: "user/monastery-progress",
  upsert: "user/monastery-progress/upsert",
};

export const ERROR_MESSAGES = {
  save: "Error saving monastery progress",
};
